import {showToastMessage} from "../../toastMessage";
import {Store} from "../../../reducers/store";
import {SOCKET_CONNECTED, STATE_HOME} from "../../../constants/default";

export const handleConnectError = (error) => {
    if (!error || !error.message) {
        return;
    }

    const message = error.message;
    const currentState = Store.getState()?.data?.currentState;
    const connectionStatus = Store.getState()?.data?.connectionStatus;

    if (message.includes('xhr poll error') && (currentState === STATE_HOME || connectionStatus === SOCKET_CONNECTED)) {
        return;
    }

    showToastMessage('SOCKET - Connection error: ' + message)
};